import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<void, "arrowButton">()(
  (theme, _params, classes) => ({
    modal: {
      zIndex: 2000,
    },
    content: {
      width: "100vw",
      height: "100svh",
      maxHeight: "100svh",
      backgroundColor: "#000000",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      "&:focus": {
        outline: "none",
      },
    },
    featuredImageSection: {
      position: "relative",
      maxHeight: "calc(100vh - 220px)",
      flex: 1,
      padding: theme.spacing(1, 16),
      "&:hover": {
        [`& .${classes.arrowButton}`]: {
          display: "block",
        },
      },
    },
    arrowButton: {
      display: "none",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "5rem",
      cursor: "pointer",
      color: theme.palette.secondary.main,
      "&:hover": {
        opacity: 0.8,
      },
    },
    arrowLeft: {
      left: theme.spacing(4),
    },
    arrowRight: {
      right: theme.spacing(4),
    },
    captionOverlay: {
      position: "absolute",
      bottom: theme.spacing(12),
      left: "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      padding: theme.spacing(2),
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#ffffff",
      borderRadius: "15px",
      width: "90vw",
      maxWidth: 605,
    },
    mobileStepperContainer: {
      display: "none",
    },
    mobileStepperDot: {
      width: "0.75em",
      height: "0.75em",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      border: `1px solid ${theme.palette.secondary.main}`,
      filter: `drop-shadow(0px 0px 1px ${theme.palette.primary.main})`,
    },
    mobileStepperDotActive: {
      backgroundColor: theme.palette.secondary.main,
    },
  })
);
